import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";
import { getCategoryCount, getHotArticles } from "@/utils/news";

interface CategorySidebarProps {
  currentSlug: string;
}

export default function CategorySidebar({ currentSlug }: CategorySidebarProps) {
  const hotList = getHotArticles(6);

  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h2 className="mb-4 flex items-center gap-2 font-serif-cn text-base font-bold text-foreground-950">
          <i className="ri-layout-grid-line text-primary-500" />
          全部栏目
        </h2>
        <ul className="space-y-1.5">
          {categories.map((item) => {
            const isActive = item.slug === currentSlug;
            return (
              <li key={item.slug}>
                <Link
                  to={`/category/${item.slug}`}
                  className={`flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  }`}
                >
                  <i className={`${item.icon} text-base`} />
                  <span className="flex-1">{item.name}</span>
                  <span className={isActive ? "text-xs text-background-100" : "text-xs text-foreground-400"}>
                    {getCategoryCount(item.slug)}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-5">
        <h2 className="mb-4 flex items-center gap-2 font-serif-cn text-base font-bold text-foreground-950">
          <i className="ri-fire-fill text-primary-500" />
          全站热榜
        </h2>
        <ol className="space-y-3">
          {hotList.map((item, index) => (
            <li key={item.id}>
              <Link to={`/article/${item.id}`} className="group flex items-start gap-3">
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded font-serif-cn text-xs font-bold ${
                    index < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-300 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition group-hover:text-primary-600">
                  {item.title}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}